module.exports = __webpack_public_path__ + "img/delivery_shipping.9b65f055.png";